import React, { useState } from "react"
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    Tooltip,
    Typography,
} from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom"
import LocalShippingIcon from "@mui/icons-material/LocalShipping"
import { logisticaItems, navbarHeight } from "../logisticaNav"
import ExpandLess from "@mui/icons-material/ExpandLess"
import ExpandMore from "@mui/icons-material/ExpandMore"

const drawerWidth = 220
const miniWidth = 70
const softColors = ["#3598DC", "#E7505A", "#8E44AD", "#32C5D2", "#C49F47"]

const logisticaGroup = {
    label: "Logística",
    icon: <LocalShippingIcon />,
    children: logisticaItems,
}

export default function SideDrawerNav({ open, onClose = () => null }) {
    const location = useLocation()
    const navigate = useNavigate()

    const groups = [logisticaGroup]

    const [openGroups, setOpenGroups] = useState({})

    const handleGroupToggle = (label) =>
        setOpenGroups((prev) => ({ ...prev, [label]: !(prev[label] ?? true) }))

    return (
        <Drawer
            variant="permanent"
            open={open}
            PaperProps={{
                sx: {
                    width: open ? drawerWidth : miniWidth,
                    transition: "width 0.2s",
                    overflowX: "hidden",
                    bgcolor: "#f5f5f5",
                    borderRight: 0,
                    boxShadow: 2,
                },
            }}
        >
            {/* El navbar queda por encima del drawer: el contenido arranca debajo */}
            <Box sx={{ height: navbarHeight, flexShrink: 0 }} />
            <List sx={{ pt: 0 }}>
                {groups.map((group, groupIdx) => (
                    <React.Fragment key={group.label}>
                        {groupIdx > 0 && <Divider sx={{ my: 1 }} />}

                        <ListItem
                            disablePadding
                            sx={{
                                px: 2,
                                py: 0.5,
                                cursor: open ? "pointer" : "default",
                                backgroundColor: softColors[groupIdx % softColors.length],
                            }}
                            onClick={() => handleGroupToggle(group.label)}
                        >
                            <ListItemIcon
                                sx={{ minWidth: 0, mr: open ? 2 : "auto", justifyContent: "center" }}
                            >
                                {group.icon}
                            </ListItemIcon>
                            {open && (
                                <ListItemText
                                    primary={
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            fontWeight={600}
                                            sx={{ letterSpacing: 1, fontSize: "0.7rem" }}
                                        >
                                            {group.label}
                                        </Typography>
                                    }
                                />
                            )}
                            {open &&
                                ((openGroups[group.label] ?? true) ? (
                                    <ExpandLess fontSize="small" />
                                ) : (
                                    <ExpandMore fontSize="small" />
                                ))}
                        </ListItem>

                        {(openGroups[group.label] ?? true) &&
                            group.children.map((item) => {
                                const isActive = location.pathname.includes(item.path)
                                return (
                                    <Tooltip
                                        key={item.path}
                                        title={!open ? item.description : ""}
                                        placement="right"
                                        arrow
                                        disableHoverListener={open}
                                    >
                                        <ListItem disablePadding sx={{ display: "block" }}>
                                            <ListItemButton
                                                selected={isActive}
                                                onClick={() => {
                                                    onClose()
                                                    navigate(`/${item.path}`)
                                                }}
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? "initial" : "center",
                                                    px: 2.5,
                                                    borderRadius: 2,
                                                    my: 0.5,
                                                    color: isActive ? "primary.main" : "inherit",
                                                    bgcolor: isActive ? "action.selected" : "transparent",
                                                    transition: "all 0.2s",
                                                }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 2 : "auto",
                                                        justifyContent: "center",
                                                        color: isActive ? "primary.main" : "inherit",
                                                    }}
                                                >
                                                    {item.icon}
                                                </ListItemIcon>
                                                {open && (
                                                    <ListItemText
                                                        primary={item.description}
                                                        sx={{
                                                            opacity: open ? 1 : 0,
                                                            "& .MuiTypography-root": { fontSize: "0.80rem" },
                                                        }}
                                                    />
                                                )}
                                            </ListItemButton>
                                        </ListItem>
                                    </Tooltip>
                                )
                            })}
                    </React.Fragment>
                ))}
            </List>
        </Drawer>
    )
}
